import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4e594a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "card-body d-flex flex-column border-radius-12 pd-b-20 p-0 justify-content-between align-items-center overflow-y"
}
const _hoisted_6 = { class: "d-flex align-items-center width-100 justify-content-center logo-header" }
const _hoisted_7 = { class: "img-box d-flex align-items-center justify-content-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ghost-img-div" }, null, -1))
const _hoisted_10 = { class: "padding-8 overflow-y full-width step-box-inside" }
const _hoisted_11 = {
  class: "step-add",
  style: {"display":"flex","align-items":"center","justify-content":"end","margin-left":"-9px"}
}
const _hoisted_12 = {
  key: 1,
  class: "card-body flex-column d-flex justify-content-center align-items-center step-add"
}
const _hoisted_13 = {
  key: 0,
  class: "loader-25"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "flex-column d-flex justify-content-center align-items-center step-add"
}
const _hoisted_16 = { class: "step-add margin-top-3" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center child add-back-child step-add"
}

import { computed, ref, nextTick } from "vue";
import { ASSETS_BASE_URL, getResolution, DEFAULT_LOGO } from "@/core/logo";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'StepBox',
  props: {
    index: {},
    step: {},
    drawerVisible: { type: Boolean },
    selectedIndex: {},
    popUpOpen: { type: Boolean },
    stepLoading: { type: Boolean },
    buttonsVisible: { type: Boolean },
    buttonIndex: {},
    type: {},
    routerEnabled: { type: Boolean },
    listIndex: {},
    selectedStep: {},
    hasLoop: { type: Boolean }
  },
  emits: [
  "open-drawer",
  "set-button-visible",
  "enable-router",
  "set-button-invisible",
  "remove-step",
  "open-delay",
  "open-filter",
  "insert-at-index",
  "disable-router",
  "add-loop",
  "end-loop",
  "open-output",
  "close-drawers",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const emit = __emit;

const stepBoxRef = ref(null);
const highlight = computed(() => {
  if (props.selectedStep) {
    if (props.selectedStep.id === props.step.id) {
      return true;
    }
  }
  return false;
});

async function onClickStepWhenStoppedIs(event, step, index, listIndex) {
  event.stopPropagation();
  await nextTick();
  emit(
    "open-drawer",
    step,
    index,
    `step${listIndex}-${index}`,
    stepBoxRef.value
  );
}
function checkWebhookConnection(step) {
  if (step.connection && step.connection.connector) {
    return (
      step.connection.connector.connectorSpecId !==
      t("Connector.WebhookConnectorSpecId")
    );
  }
  return true;
}

const isFirstStep = computed(() => props.index === 0);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex box-210 stepBoxCount",
    id: `step-id-${_ctx.step.id}`,
    ref_key: "stepBoxRef",
    ref: stepBoxRef
  }, [
    _createElementVNode("div", {
      class: "d-flex flex-column step",
      id: `step-unique-${_ctx.step.uniqueId}`
    }, [
      _createElementVNode("div", {
        class: "d-flex flex-row step-section",
        id: _ctx.index
      }, [
        _createElementVNode("div", {
          class: "d-flex justify-content-center align-items-center primary-bg secondary-border number-box-shadow step-number-badge",
          style: _normalizeStyle({ fontSize: _ctx.step.ix + 1 > 99 ? '12px' : '14px' })
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.step.ix ? _ctx.step.ix + 1 : 1), 1)
        ], 4),
        _createElementVNode("div", {
          class: _normalizeClass(["card border-radius-12 square-div-120", {
            handle:
              !_ctx.popUpOpen &&
              _ctx.step.connectorSpecId &&
              !_ctx.step.connectorSpecId.includes('webhook'),
            highlight: highlight.value,
          }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickStepWhenStoppedIs($event, _ctx.step, _ctx.index, _ctx.listIndex))),
          onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (emit('set-button-visible', _ctx.index))),
          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (emit('set-button-invisible'))),
          id: `step${_ctx.listIndex}-${_ctx.index}`
        }, [
          (_ctx.step.connection || _ctx.step.connectorSpecId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "logo-step-header",
                      src: `${_unref(ASSETS_BASE_URL)}/${
                    _ctx.step.connection?.connector?.connectorSpecId ??
                    _ctx.step.connectorSpecId
                  }${_unref(getResolution)(true)}.png`,
                      alt: "logo"
                    }, null, 8, _hoisted_8)
                  ]),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.step.output)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "stepbox-btn btn btn-link",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('open-output', _ctx.index, _ctx.step)), ["stop"]))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "database" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.step.delay)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "stepbox-btn btn btn-link",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('open-delay', _ctx.index, _ctx.step)), ["stop"]))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            class: "fa-sm",
                            icon: "hourglass-start"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.step?.filter?.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: _normalizeClass([{ 'mg-l-7': _ctx.step.delay }, "stepbox-btn btn btn-link"]),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emit('open-filter', _ctx.index, _ctx.step)), ["stop"]))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            class: "fa-sm",
                            icon: "filter"
                          })
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h6", {
                    class: _normalizeClass([{ 'pd-t-8': !_ctx.step.delay && !_ctx.step.filter?.length }, "font-size-12 step-name"]),
                    style: {"margin-bottom":"0 !important","text-align":"center","overflow-y":"auto"}
                  }, _toDisplayString(_ctx.step.name), 3)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.stepLoading && _ctx.selectedIndex === _ctx.index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                        alt: "Loading...",
                        class: "loader-logo-25"
                      }, null, 8, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "fa-m step-add",
                        icon: "plus"
                      }),
                      _createElementVNode("strong", _hoisted_16, _toDisplayString(_unref(t)("Common.Add")), 1)
                    ]))
              ]))
        ], 42, _hoisted_4),
        (checkWebhookConnection(_ctx.step))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["col parent-add-back-step", {
            'buttons-visible': _ctx.buttonsVisible && _ctx.buttonIndex === _ctx.index,
          }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('insert-step-before', _ctx.index, _ctx.step))),
              onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (emit('set-button-visible', _ctx.index))),
              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (emit('set-button-invisible')))
            }, [
              (!_ctx.routerEnabled && isFirstStep.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "step-add",
                        icon: "plus"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 34))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["col parent", {
            'buttons-visible': _ctx.buttonsVisible && _ctx.buttonIndex === _ctx.index,
          }]),
          onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (emit('set-button-visible', _ctx.index))),
          onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (emit('set-button-invisible')))
        }, [
          _createElementVNode("div", {
            class: "d-flex justify-content-center align-items-center child child-1 step-add",
            id: "flow-remove-step",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('remove-step', _ctx.index, _ctx.step)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "times",
              size: "sm"
            })
          ]),
          (!_ctx.routerEnabled)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-flex flex-column justify-content-center align-items-center child child-2 step-add",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('insert-at-index', _ctx.index + 1, _ctx.step.ix + 1, _ctx.step.iy))),
                id: "flow-add-step"
              }, [
                _createElementVNode("div", null, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "step-add",
                    icon: "plus"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ], 34)
      ], 8, _hoisted_3)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})